
define('text!templates/widgets/dataGridCells/enabledCell.html',[],function () { return '<button class="btn" data-bind="flipswitch: enabled,\n                               waitButton: loading">\n</button>\n';});

